<template>
  <div style="width: 90%; margin: auto;">
    <div style="text-align: center; font-size: 36px; font-weight: bolder; color: black; margin: 10px">
      <label style="margin-right: 20px">客</label>
      <label style="margin-right: 20px">户</label>
      <label style="margin-right: 20px">看</label>
      <label style="margin-right: 20px">板</label>
    </div>
    <div v-loading="!$store.state.work.loaded" style="display: flex;">

      <el-table v-if="$store.state.work.loaded"
                :data="currentWorkList"
                style="width: 0; flex-grow: 3; margin-right: 12px; background-color: rgb(243, 245, 251)"
                :height="leftTableHeight"
                stripe>
        <!--<el-table-column align="center" label="车主姓名" prop="ownerName"></el-table-column>-->
        <el-table-column align="center" label="车牌号" prop="carNo"></el-table-column>
        <el-table-column align="center" label="当前工序" prop="procedureName"></el-table-column>
        <el-table-column align="center" label="预计交车时间" prop="estimateDeliveryTime" min-width="135"></el-table-column>
        <el-table-column align="center" label="接待" prop="consultantName"></el-table-column>
      </el-table>

      <div v-if="$store.state.work.loaded" style="width: 0; flex-grow: 1" class="right">
        <div
          style="height: 88px; line-height: 88px; text-align: center; font-size: 40px; font-weight: bolder; background-color: #4A95F0; color: black;">
          请您取车
        </div>
        <!-- <div style="height: 2px; background-color: gray"></div> -->
        <el-table :data="currentDeliveryWorkList" stripe :height="rightTableHeight" style="background-color: rgb(243, 245, 251)">
          <el-table-column align="center" label="车牌号" prop="carNo"></el-table-column>
          <el-table-column align="center" label="车主姓名" prop="ownerName"></el-table-column>
        </el-table>
      </div>

    </div>
    <div v-if="myOrgan"
         style="text-align: center; margin: 10px 0; font-size: 20px; font-weight: bolder; color: #606266">
      欢迎光临{{myOrgan.name}}，预约、维修服务热线：{{myOrgan.cellphone}}
    </div>
  </div>
</template>

<script>
  import { shareDataMixin } from '@/views/mixins/ShareData'
  import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'

  export default {
    name: 'CustomerKanban',
    mixins: [shareDataMixin, resizeCaptureMixin],
    data () {
      return {
        pageSize: 12,
        currentPage: 1,
        right: {
          pageSize: 10,
          currentPage: 1
        }
      }
    },
    mounted () {
      const timer = setInterval(() => {
        if (!this.$store.state.work.loaded) return
        ++this.currentPage
        if (this.currentPage * this.pageSize + 1 > this.workList.length) {
          this.currentPage = 1
        }
        ++this.right.currentPage
        if (this.right.currentPage * this.right.pageSize + 1 > this.deliveryWorkList.length) {
          this.right.currentPage = 1
        }
      }, 3000)
      this.$once('hook:beforeDestroy', () => clearInterval(timer))
    },
    created () {
      this.$store.dispatch('work/getKanbanWorks', 0)
    },
    computed: {
      workList () {
        debugger
        const list = [...this.$store.state.work.beginWork.workList]
        for (const workColumns of this.$store.state.work.middleWorks) {
          for (const column of workColumns) {
            list.push(...column.workList)
          }
        }
        list.push(...this.$store.state.work.endWorks[0].workList)
        return list.filter(work => work.estimateDeliveryTime.split(' ')[0] === new Date().format('yyyy-MM-dd'))
      },
      deliveryWorkList () {
        return this.$store.state.work.endWorks[1].workList
      },
      currentWorkList () {
        const startIndex = (this.currentPage - 1) * this.pageSize
        return this.workList.slice(startIndex, startIndex + this.pageSize)
      },
      currentDeliveryWorkList () {
        const startIndex = (this.right.currentPage - 1) * this.right.pageSize
        return this.deliveryWorkList.slice(startIndex, startIndex + this.right.pageSize)
      },
      leftTableHeight () {
        return this.clientHeight - 217
      },
      rightTableHeight () {
        return this.clientHeight - 307
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ {
    th {
      height: 50px;
    }

    .el-table th.el-table__cell {
      background-color: #4A95F0;
      color: black;
      font-size: 17px;
    }

    .el-table--enable-row-transition .el-table__body td.el-table__cell {
      background-color: #e7eaf1!important
    }

    .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
      background-color: white !important;;
    }

    .right {
      th {
        height: 48px;
      }

      .el-table--enable-row-transition .el-table__body td.el-table__cell {
        background-color: #e7eaf1 !important;
      }

      .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
        background-color: white !important;;
      }

      .el-table__cell {
        color: black;
      }
    }

    .el-table__cell {
      color: black;
      font-weight: bold;
      font-size: 15px;
      border-bottom: 0 !important;
    }

    .el-table .cell {
      line-height: 28px !important;
    }
  }
</style>
